import { lang } from '@ott/l10n';

// We need to declare the window.__gCrWeb variable
// in order to prevent the 'Can't find variable: __gCrWeb'
// error in the mobile Chrome browser.
// https://solartripdev.atlassian.net/browse/LAN-1171
import './utility/gCrWebDeclare';

import { testOttDomain } from 'helpers/common';
import Cookie from 'js-cookie';
import { TrackJS } from 'trackjs';
import { startCommonCookieLogic } from 'utility/cookieLogic';
import trackError from 'utility/trackError';

function initTrackJs() {
  const envId = document.documentElement.getAttribute('data-envid');
  const isTrackJsInitializationNeeded = envId && 'production'.includes(envId);

  if (!isTrackJsInitializationNeeded) {
    return;
  }

  // eslint-disable-next-line no-underscore-dangle
  TrackJS.install({
    token: '9434784669a9411185e8a512654b173a',
    application: 'solartrip',
    userId: Cookie.get('vid') || '',
  });

  TrackJS.addMetadata('repo', 'front-solar-landings');
  TrackJS.addMetadata('environment', envId);

  global.trackJs = TrackJS;
}

if (__PROD__ && testOttDomain()) {
  initTrackJs();
}

function blockAdFoxYandexPixel() {
  try {
    const srcPropertyDescriptor = Object.getOwnPropertyDescriptor(Image.prototype, 'src');

    const oldSrcSet = srcPropertyDescriptor.set;

    Object.defineProperty(Image.prototype, 'src', {
      ...srcPropertyDescriptor,
      set: function (value) {
        // запрещаем грузить пиксель Яндекса
        if (value && value?.includes?.('an.yandex.ru/mapuid/yandex')) {
          return;
        }
        oldSrcSet.call(this, value);
      },
    });
  } catch (err) {
    trackError(err);
  }
}

blockAdFoxYandexPixel();
startCommonCookieLogic(lang);

(async () => {
  try {
    import(/* webpackMode: "eager" */ './client');
  } catch (e) {
    trackError(e);
  }
})();
